// imports
import MenuOverlay from 'minsky-kit/js/components/MenuOverlay';

// private statics

// class definition
export default class CTMenuOverlay extends MenuOverlay {
    // constructor
    constructor (args = {}, objectName = 'MenuOverlay') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);
    }

    // methods
    refresh (...args) {
        super.refresh(...args);
    }

    show (...args) {
        super.show(...args);
    }

    destroy () {
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
